class TooltipEdgeDetector {
  constructor(options = {}) {
    this.animateSection = document.querySelector(".animate-section");
    this.scrollingWrapper = document.querySelector(".scrolling-wrapper");
    this.edgeThreshold = options.edgeThreshold || 100;
    this.memberItems = [];
    this.isAnimating = true;

    if (!this.animateSection) {
      console.warn("[TooltipEdgeDetector] .animate-section not found");
      return;
    }

    this.init();
  }

  init() {
    this.memberItems = Array.from(
      this.animateSection.querySelectorAll(".member-item")
    );

    this.animateSection.addEventListener(
      "mouseenter",
      () => (this.isAnimating = false)
    );
    this.animateSection.addEventListener(
      "mouseleave",
      () => (this.isAnimating = true)
    );

    this.startMonitoring();
  }

  startMonitoring() {
    const checkPositions = () => {
      this.memberItems.forEach((member) => {
        this.updateTooltipPosition(member);
      });

      if (this.isAnimating) {
        requestAnimationFrame(checkPositions);
      } else {
        setTimeout(() => checkPositions(), 100);
      }
    };

    checkPositions();
  }

  updateTooltipPosition(memberElement) {
    const rect = memberElement.getBoundingClientRect();
    const sectionRect = this.animateSection.getBoundingClientRect();

    const relativeLeft = rect.left - sectionRect.left;
    const relativeRight = sectionRect.right - rect.right;

    // Remove all position classes
    memberElement.classList.remove(
      "tooltip-left-edge",
      "tooltip-right-edge",
      "tooltip-default",
    );

    if (relativeLeft < this.edgeThreshold) {
      // Member is near left edge
      memberElement.classList.add("tooltip-left-edge");
      memberElement.dataset.edgeZone = "left";
    } else if (relativeRight < this.edgeThreshold) {
      // Member is near right edge
      memberElement.classList.add("tooltip-right-edge");
      memberElement.dataset.edgeZone = "right";
    } else {
      // Member is in safe zone
      memberElement.classList.add("tooltip-default");
      memberElement.dataset.edgeZone = "center";
    }
  }

  setEdgeThreshold(pixels) {
    this.edgeThreshold = pixels;
  }

  getEdgeThreshold() {
    return this.edgeThreshold;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.tooltipDetector = new TooltipEdgeDetector({
    edgeThreshold: 150,
  });
});
